export default __webpack_public_path__ + "static/speechToText-9952d9de789335b97b643bfc12db8e82.png";